<template>
  <div>
    <img
      src="@/assets/tarjeta_beneficios_talleres_calidad.jpg"
      style="width: 100%"
    />
    <p class="tituloTarjeta">TALLERES CALIDAD PREMIUM</p>

    <ul style="list-style-type: disc">
      <li>Entrega de partes de accidente en el Taller.</li>
      <li>Peritación inmediata por sistema de video-peritación.</li>
      <li>Recogida y entrega de vehículo (según proximidad).</li>
      <li>Vehículo de cortesía (consultando disponibilidad).</li>
      <li>Recogida y entrega del vehículo (según proximidad).</li>
      <li>Preferencia en la reparación.</li>
      <li>Limpieza del vehículo.</li>
      <li>Reducción del tiempo de reparación.</li>
    </ul>

    <p class="container-flex">
      <a
        href="https://www.mmtseguros.com/atencion-cliente/buscar-taller/"
        target="_blank"
        class="link"
      >
        <button class="pure-button botonLlamar">Buscar Taller</button>
      </a>
    </p>
  </div>
</template>

<script>
export default {
  methods: {
    email() {},
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-bottom: 3rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 9rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}

.link {
  color: $colorMMT;
  font-weight: 460;
  margin-right: 3rem;
}
</style>
